'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import Link from 'next/link';
import { useMonthNavigation } from './use-month-navigation';
interface MonthNavigationProps {
  availableMonths: Date[];
  defaultMonth: Date;
}
function MonthNavigation(t0) {
  const $ = _c(22);
  const {
    availableMonths,
    defaultMonth
  } = t0;
  let t1;
  if ($[0] !== availableMonths || $[1] !== defaultMonth) {
    t1 = {
      availableMonths,
      defaultMonth
    };
    $[0] = availableMonths;
    $[1] = defaultMonth;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    selectedMonth,
    selectedMonthDisplay,
    previousMonth,
    nextMonth,
    createUrl
  } = useMonthNavigation(t1);
  let t2;
  if ($[3] !== createUrl || $[4] !== previousMonth) {
    t2 = previousMonth ? <Button asChild={true} variant="ghost" size="icon" aria-label="Previous month"><Link href={createUrl(previousMonth)}><ChevronLeft className="text-foreground size-4" /></Link></Button> : <Button variant="ghost" size="icon" aria-label="Previous month" disabled={true}><ChevronLeft className="text-foreground size-4" /></Button>;
    $[3] = createUrl;
    $[4] = previousMonth;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== createUrl || $[7] !== nextMonth) {
    t3 = nextMonth ? <Button asChild={true} variant="ghost" size="icon" aria-label="Next month"><Link href={createUrl(nextMonth)}><ChevronRight className="text-foreground size-4" /></Link></Button> : <Button variant="ghost" size="icon" aria-label="Next month" disabled={true}><ChevronRight className="text-foreground size-4" /></Button>;
    $[6] = createUrl;
    $[7] = nextMonth;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className="flex gap-2">{t2}{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== selectedMonth) {
    t5 = selectedMonth.getUTCFullYear();
    $[12] = selectedMonth;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = String(selectedMonth.getUTCMonth() + 1);
  let t7;
  if ($[14] !== t6) {
    t7 = t6.padStart(2, "0");
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = `${t5}-${t7}`;
  let t9;
  if ($[16] !== selectedMonthDisplay || $[17] !== t8) {
    t9 = <time className="text-foreground/50 text-base/6 font-semibold sm:text-xl/[120%] sm:font-bold" dateTime={t8} aria-live="polite">{selectedMonthDisplay}</time>;
    $[16] = selectedMonthDisplay;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t4 || $[20] !== t9) {
    t10 = <nav className="flex items-center gap-2" aria-label="Month navigation">{t4}{t9}</nav>;
    $[19] = t4;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}
export { MonthNavigation };